import { MainWrapperViewImpl } from '../mainwrapperview';
import { MainWrapperComponentProps} from '../mainwrappercomponent';
import { UIComponentState } from '../../toolkit/uicomponent';
import { MainWrapperCSSStyle } from '../mainwrappercss';
import * as React from 'react';

export class LoginWrapperViewImpl extends MainWrapperViewImpl
{
    draw(props: MainWrapperComponentProps, state: UIComponentState, cssStyle: MainWrapperCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <>
            <div>
            <div style={cssStyle.getMainWrapperCSSStyle()}>
              
                <div style={{width:'100%',height:'100%',}}>
                {
                    this.createHeaderComponent()
                }
               
                </div>
                
            </div>
               
                <div  style={cssStyle.getContentDivCSSStyle()}>
                {
                   props.childComponent
                }
                </div>
            
            </div>
           
            </>);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/login/loginwrapperview.tsx